import { AttendanceLogs } from "./Attendance";
import { AttendanceDSMLogs } from "./AttendanceDSM";
import { N18_TER_AttendanceLogs } from "./N18_TER_AttendanceLogs";


export const AttendanceReport = {
  "sections": [
    AttendanceLogs,
    AttendanceDSMLogs,
    N18_TER_AttendanceLogs
  ]
}